<div class="modal-header">
    <h4 class="modal-title pull-left">Add Tickers</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="form-group">
        <label class="form-label">Ticker Name</label>
        <input class="form-control" #TickerName="ngModel" maxlength="50" [(ngModel)]="tickerName" required type="text">
        <p class="redtext" *ngIf="(Validation.IsinValid(tickerName) && isSubmit) ||(TickerName.invalid && TickerName.touched)">Ticker Name is required </p>
    </div>
    <div class="text-left">
        <button class="right-btn btn-border margin-right-10 btn adduserbtn margin-bottom-15" (click)="searchTickers()">Search</button>
    </div>
    <div class="form-group">
        <table class="table basictable row-border hover">
            <tbody>
                <tr *ngFor="let ticker of tickerResponse;">
                    <td>
                        <ul class="connection-list brokerlist be-exchange-list">
                            <li class="clearfix">
                                <div class="right">
                                    <h6>
                                        {{ticker.name}} - <span style="color:lightseagreen">{{ticker.symbol}}</span>
                                    </h6>
                                    <p>
                                        {{ticker.exchDisp}}
                                    </p>
                                </div>
                            </li>
                        </ul>
                        <p><a href="javascript:void(0);" class="be-small-atag pull-right" (click)="onTickerSelect(ticker.name,ticker.symbol,ticker.exchDisp)">Select</a></p>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="nodata" *ngIf="showNoData">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Tickers Found</p>
        </div>
    </div>
    <div class="form-group">
        <table class="table basictable row-border hover">
            <tbody>
                <tr *ngFor="let ticker of selectedticker;">
                    <td class="selected-ticker-td">
                        <h6 style="font-size:15px;color:#198fde">Selected Ticker :</h6>
                        <ul class="connection-list brokerlist be-exchange-list">
                            <li class="clearfix">
                                <div class="right">
                                    <h6>
                                        {{ticker.name}} - <span style="color:lightseagreen">{{ticker.symbol}}</span>
                                    </h6>
                                    <p>
                                        {{ticker.exchDisp}}
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="text-right" *ngIf="selectedticker?.length > 0">
        <button class="btn btn-default btn-lg" id="closeModal" (click)="modalRef.hide();">Cancel</button>
        <button class="btn btn-success btn-lg" (click)="onSaveTicker();">Save</button>
    </div>
</div>